module.exports = __webpack_public_path__ + "static/can_boys_bottom_payoff_1600px-dc8fe1eb5d380306f9555dda0425a925.jpg";